import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { fetchFaqs } from "../../../actions/faq.action";
import { useDispatch, useSelector } from "react-redux";
import { Loading } from "../../../utils/helpers/constants";
import RoundLoader from "../../../components/loader/RoundLoader";
import { Collapse } from "antd";

export default function Faq() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { Panel } = Collapse;

  const {
    faq: { faqs, loading },
  } = useSelector(({ faqReducer }) => ({
    faq: faqReducer,
  }));

  const { profile } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  useEffect(() => {
    dispatch(fetchFaqs());
  }, []);

  const loadState =
    loading === Loading.FETCHING ||
    profile.userProfileLoading === Loading.FETCHING;

  return (
    <div className="">
      <div className="doc_processing_color h-40 px-4 pt-6">
        <div className="text-md">
          <AiOutlineArrowLeft
            size={25}
            onClick={() => history.goBack()}
            className="mb-5 cursor-pointer"
          />
          <span className="text-2xl md:text-2xl text-green-800 font-serif font-bold">
            FAQ
          </span>
        </div>
        <div className="text-md">
          Gain insight to the most ask question in the community and find
          answers quickly
        </div>
      </div>
      <div className="px-4 pt-6">
        {loadState ? (
          <RoundLoader />
        ) : (
          <>
            <Collapse
              defaultActiveKey={["1"]}
              // onChange={onChange}
              expandIconPosition={"end"}
            >
              {faqs.map(({ question, answer }, index) => (
                <Panel header={question} key={index} className="text-bold">
                  <div>{answer}</div>
                </Panel>
              ))}
              {/* {faqs.map(({ question, answer }, index) => (
            <Accordion title={question} content={answer} />
          ))} */}
            </Collapse>
          </>
        )}
      </div>
    </div>
  );
}
